import {lazy} from 'react';

const loadModule = () => import('./routes/ModuleRoutes');
export const DocumentationModule = lazy(loadModule);

export default DocumentationModule;
